import { Leurre } from './leurre.model';
import { Echantillon } from './echantillon.model';
import { ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class EchantillonJury {
    static jsonMap = {
        leurre: { key: 'leurre', converter: new (ClassConverterFactory.build(Leurre))(), optional: true },
        echantillon: { key: 'echantillon', converter: new (ClassConverterFactory.build(Echantillon))(), optional: true },
        ordre: { key: 'ordre' },
        numeroAnonymat: { key: 'numeroAnonymat' },
        degre: { key: 'degre', optional: true },
        volume: { key: 'volume', optional: true }
    };

    leurre: Leurre;
    echantillon: Echantillon;
    ordre: number;
    numeroAnonymat: string;
    degre: number;
    volume: number;

    numeroJury: number;
}
